__turbopack_context__.v({
  "container": "inviteFriendsModal-module__VmdZ4G__container",
  "header": "inviteFriendsModal-module__VmdZ4G__header",
  "inviteLinks": "inviteFriendsModal-module__VmdZ4G__inviteLinks",
  "subtitle": "inviteFriendsModal-module__VmdZ4G__subtitle",
  "winWithFriendsBadge": "inviteFriendsModal-module__VmdZ4G__winWithFriendsBadge",
  "winWithFriendsLimit": "inviteFriendsModal-module__VmdZ4G__winWithFriendsLimit",
});
